// base
import { chartDashboardBoxStyle } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledWeatherGraphCard = styled.div`
  ${chartDashboardBoxStyle}

  position: relative !important;
  width: 457px;
  min-width: 457px;
  height: 330px;

  .weather-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 22px;

    p {
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
    }
  }

  .today-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 28px;

    &-left {
      > h3 {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
        margin-bottom: 10px;
      }

      &-box {
        > p {
          font-size: 36px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }

        .high-low {
          color: #585959;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;

          display: flex;
          align-items: center;
          gap: 12px;
        }
      }
    }

    &-right {
      width: 128px;
      height: 128px;

      > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  .time-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow-x: auto;
    gap: 32px;

    &-box {
      display: flex;
      flex-direction: column;
      width: 40px;

      > p {
        color: #585959;
        text-align: center;
        font-size: 12px;
        font-style: normal;
        line-height: normal;
      }

      .time {
        font-weight: 400;
      }

      .demo {
        font-weight: 600;
      }

      > img {
        width: 40px;
        height: 40px;
        object-fit: contain;
        margin-bottom: 8px;
      }
    }
  }
`;
